module.exports = __webpack_public_path__ + "resources/img/sp_gnb_m.e937d505c8a9ef361307b83e50b43523.png";